<template>
  <div class="photoStart">
    <LoadingPlaceholder v-if="preparing == true" />
    <template v-if="spotOneValue || spotTwoValue">
      <div
        id="nav-tab"
        class="nav nav-tabs"
        role="tablist"
      >
        <a
          v-if="spotOneValue"
          id="spoTOne-tab"
          class="nav-item nav-link active"
          data-toggle="tab"
          href="#spoTOne"
          role="tab"
          aria-controls="spoTOne"
          aria-selected="true"
        >Spot: {{ spotOneValue.spotId }}</a>
        <a
          v-if="spotTwoValue"
          id="spotTwo-tab"
          class="nav-item nav-link"
          data-toggle="tab"
          href="#spotTwo"
          role="tab"
          aria-controls="spotTwo"
          aria-selected="false"
        >Spot: {{ spotTwoValue.spotId }}</a>
      </div>
      <div
        id="nav-tabContent"
        class="tab-content"
      >
        <div
          v-if="spotOneValue"
          id="spoTOne"
          class="tab-pane fade show active"
          role="tabpanel"
          aria-labelledby="spoTOne-tab"
        >
          <SessionOverview
            :runs="spotOneValue.items"
            :display-properties="['createDate', 'card']"
            :loading="loading"
            :filter="filter"
            :installation-type="installationType"
            :installation-id="installationId"
            @loadSessions="loadSessions"
          />
        </div>
        <div
          v-if="spotTwoValue"
          id="spotTwo"
          class="tab-pane fade"
          role="tabpanel"
          aria-labelledby="spotTwo-tab"
        >
          <SessionOverview
            :runs="spotTwoValue.items"
            :display-properties="['createDate', 'card']"
            :loading="loading"
            :filter="filter"
            :installation-type="installationType"
            :installation-id="installationId"
            @loadSessions="loadSessions"
          />
        </div>
      </div>
    </template>

    <!-- <SessionOverview
      v-else-if="photos && photos.spotOne && photos.spotOne.length > 0"
      :display-properties="['createDate', 'card']"
      :runs="photos.spotOne"
      :installation-type="installationType"
      :loading="loading"
      :filter="filter"
      :installation-id="installationId"
      @loadSessions="loadSessions"
    />

    <SessionOverview
      v-else-if="photos && photos.spotTwo && photos.spotTwo.length > 0"
      :display-properties="['createDate', 'card']"
      :runs="photos.spotTwo"
      :installation-type="installationType"
      :loading="loading"
      :filter="filter"
      :installation-id="installationId"
      @loadSessions="loadSessions"
    /> -->

    <p v-else-if="preparing == false && !spotOneValue && !spotTwoValue">
      No data available.
    </p>

    <SweetModal
      :id="modalId"
      ref="photoStartmodal"
      title="Session"
      width="75%"
      @closeModal="closeModal"
    >
      <template slot="box-action">
        <toggle-button
          v-model="viewDecoratedPhotos"
          :labels="{ checked: 'decorated', unchecked: 'normal' }"
          :width="100"
          :height="30"
          :font-size="12"
          class="mr-3 mt-2"
        />
      </template>
      <sweet-modal-tab
        id="tab1"
        title="Photo"
      >
        <LoadingPlaceholder v-if="itemLoading" />
        <template v-else>
          <img
            v-if="altImageAvailable"
            id="img"
            :src="altImageUrl"
            class="img-fluid"
          />
          <ImagePlaceholderSvg
            v-else
            class="img-fluid"
          />
        </template>
      </sweet-modal-tab>

      <sweet-modal-tab
        id="tab2"
        title="Details"
      >
        <table
          v-if="photostart != null"
          class="defaultTable"
        >
          <colgroup>
            <col width="200" />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <th>Id</th>
              <td class="lineBreaks">
                {{ photostart.id }}
              </td>
            </tr>
            <tr>
              <th>Card Number</th>
              <td class="lineBreaks">
                {{ photostart.cardId ? photostart.cardId.id : "" }}
              </td>
            </tr>
            <tr>
              <th>Create date</th>
              <td v-tooltip="dateTime_fromNow(photostart.startTime)">
                {{ dateTime_dateTime(photostart.startTime) }}
              </td>
            </tr>
            <tr>
              <th>Image Url</th>
              <td>
                {{
                  photostart.media && photostart.media.hd
                    ? photostart.media.hd.url
                    : ""
                }}
              </td>
            </tr>
            <tr>
              <th>Snapshot Url</th>
              <td>
                {{
                  photostart.media && photostart.media.preview
                    ? photostart.media.preview.url
                    : ""
                }}
              </td>
            </tr>
            <tr>
              <th>Point Id</th>
              <td>{{ photostart.pointId }}</td>
            </tr>
            <tr>
              <th>External Ids</th>
              <td class="lineBreaks">
                <template v-if="photostart.externalIds && photostart.externalIds.length > 0">
                  <div
                    v-for="(externalId, index) in photostart.externalIds"
                    :key="`photostart-externalId-${ index }`"
                  >
                    {{ externalId.type }}: {{ externalId.number }}
                  </div>
                </template>
                <template v-else>
                  {{ $t("noDataAvailable") }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </sweet-modal-tab>
      <sweet-modal-tab
        id="tab3"
        title="EXIF"
      >
        <pre v-if="exifData">{{ exifData }}</pre>
        <template v-else>
          {{ $t("noDataAvailable") }}
        </template>
      </sweet-modal-tab>
    </SweetModal>
  </div>
</template>

<script>
import { dateTimeMixin } from "@/mixins/dateTimeMixin.js";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";

export default {
  name: "PhotoStart",
  components: {
    ImagePlaceholderSvg: () =>
      import("@/components/Base/ImagePlaceholderSvg.vue"),
    SessionOverview: () => import("@/components/Media/SessionOverview.vue"),
    SweetModal,
    SweetModalTab,
  },
  mixins: [dateTimeMixin],
  props: {
    installationId: {
      type: String,
      required: true,
    },
    installationType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      useAlternativeFilter: true,
      loading: true,
      photos: null,
      altImageUrl: "",
      modalId: "photostartModal",
      filter: {
        dates: null,
        cardNumber: null,
        startDate: null,
        endDate: null,
        showIncomplete: true,
        limit: 100,
      },
      preparing: true,
      payload: null,
      photostart: null,
      viewDecoratedPhotos: true,
      exifData: null,
      itemLoading: false,
    };
  },
  computed: {
    spotOneValue() {
      if (this.photos && this.photos.length > 0 && this.photos[0]) {
        return this.photos[0];
      }
      return null;
    },
    spotTwoValue() {
      if (this.photos && this.photos.length > 1 && this.photos[1]) {
        return this.photos[1];
      }
      return null;
    },
    altImageAvailable: function () {
      if (
        !this.itemLoading && ((this.getDecoratedImageUrl(this.payload)) ||
        (this.photostart &&
          this.photostart.media &&
          this.photostart.media.hd &&
          this.photostart.media.hd.url))
      ) {
        return true;
      }
      return false;
    },
  },
  watch: {
    viewDecoratedPhotos(val) {
      if (this.altImageAvailable) {
        this.altImageUrl = val
          ? this.getDecoratedImageUrl(this.payload) || this.getStandardImageUrl(this.photostart)
          : this.photostart &&
            this.photostart.media &&
            this.photostart.media.hd &&
            this.photostart.media.hd.url
          ? this.photostart.media.hd.url
          : this.getDecoratedImageUrl(this.payload);
      }
    },
  },
  created() {
    let tmpDate = new Date(Date.now());
    this.filter.startDate = new Date(
      tmpDate.getFullYear(),
      tmpDate.getMonth(),
      tmpDate.getDate() - 1,
      0,
      0,
      0
    );
    this.filter.endDate = new Date(
      tmpDate.getFullYear(),
      tmpDate.getMonth(),
      tmpDate.getDate(),
      23,
      59,
      59
    );
    this.filter.dates = [];
    this.filter.dates.push(this.filter.startDate, this.filter.endDate);

    this.loadSessions();
    this.$eventBus.$on(`openModal${this.modalId}`, this.openModal);
  },
  beforeDestroy() {
    this.$eventBus.$off(`openModal${this.modalId}`, this.openModal);
  },
  methods: {
    getDecoratedImageUrl(payload) {
      if (!payload) {
        return null;
      }

      return payload.decoratedUrl || payload.brandedImageUrl || null;
    },
    getStandardImageUrl(payload) {
      if (!payload) {
        return null;
      }

      if (payload.media && payload.media.hd && payload.media.hd.url) {
        return payload.media.hd.url;
      }

      return payload.url || payload.imageUrl || null;
    },
    getItem(id) {
      this.itemLoading = true;
      this.axios
        .get(`/Media/GetItem/${id}`)
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          this.photostart = response.data;
          this.getExifData(this.photostart);
          if (this.viewDecoratedPhotos) {
            this.altImageUrl = this.getDecoratedImageUrl(this.payload) || this.getStandardImageUrl(this.photostart);
          } else {
            this.altImageUrl = this.getStandardImageUrl(this.photostart);
          }
        })
        .finally(() => {
          this.itemLoading = false;
        });
    },
    openModal(payload) {
      this.payload = payload;
      if (this.isChinaInstallation) {
        this.viewDecoratedPhotos = false;
      }
      this.getItem(payload.id);
      this.$refs.photoStartmodal.open();
    },
    closeModal() {
      this.payload = null;
      this.photostart = null;
      this.altImageUrl = "";
      this.exifData = null;
      this.$refs.photoStartmodal.close();
    },
    // GET DEVICE gets the data for the device specified by the deviceId
    loadSessions(payload) {
      if (payload == null || this.useAlternativeFilter == true) {
        payload = {
          limit: 100,
          dates: [
            this.useAlternativeFilter == true ? null : this.filter.startDate,
            this.useAlternativeFilter == true ? null : this.filter.endDate,
          ],
        };
      }
      this.loading = true;
      const reqObj = {
        installationId: this.installationId,
        startDate: this.dateTime_isoString(payload.dates[0]),
        endDate: this.dateTime_isoString(payload.dates[1]),
        limit: payload.limit
      }
      this.axios
        .post(
          `/Media/GetPhotostartMedia`, reqObj
        )
        .then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          if (response.data.length === 0) {
            return;
          }

          this.photos = response.data;
        })
        .finally(() => {
          this.loading = false;
          window.setTimeout(() => {
            this.preparing = false;
          }, 500);
        });
    },
    getExifData(payload) {
      if (payload.media && payload.media.hd && payload.media.hd.url) {
        var urlObj = {
          url: payload.media.hd.url,
        };

        this.axios.post(`/Media/GetExifData`, urlObj).then((response) => {
          if (response == null) {
            return;
          }
          if (response.data == null) {
            return;
          }
          if (response.data) {
            this.exifData = JSON.stringify(JSON.parse(response.data), null, 2);
          }
        });
      }
    },
  },
};
</script>
